// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-layouts----Footer-module---footer---XJsU0","content":"src-layouts----Footer-module---content---2aJ_2","content_ort":"src-layouts----Footer-module---content_ort---1ywAy","content_imp":"src-layouts----Footer-module---content_imp---3a5S9","impressum":"src-layouts----Footer-module---impressum---1bg06"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Footer.module.css
// module id = 615
// module chunks = 114276838955818